import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../pages/Homepage.css";
import Navbar from "../pages/Navbar";
import Footer from "../pages/Footer";
import aboutlap from "./Homepage/Images/aboutlap.svg";

const CountdownTimer = ({
  initialDays = 0,
  initialHours = 0,
  initialMinutes = 1,
  initialSeconds = 0,
}) => {
  const [days, setDays] = useState(initialDays);
  const [hours, setHours] = useState(initialHours);
  const [minutes, setMinutes] = useState(initialMinutes);
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else if (seconds === 0 && minutes > 0) {
        setMinutes(minutes - 1);
        setSeconds(59);
      } else if (minutes === 0 && hours > 0) {
        setHours(hours - 1);
        setMinutes(59);
        setSeconds(59);
      } else if (hours === 0 && days > 0) {
        setDays(days - 1);
        setHours(23);
        setMinutes(59);
        setSeconds(59);
      } else if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
        clearInterval(timerInterval);
      }
    }, 1000);

    // Clean up the interval when the component unmounts
    return () => clearInterval(timerInterval);
  }, [days, hours, minutes, seconds]);

  return (
    <div className="countdown-container">
      <h1 className="countdown-heading">Launching In</h1>
      <div className="timer">
        <div className="time-container">
          <span className="time">{days < 10 ? `0${days}` : days}</span>
          <span className="label">Days</span>
        </div>
        <span className="colon">:</span>
        <div className="time-container">
          <span className="time">{hours < 10 ? `0${hours}` : hours}</span>
          <span className="label">Hours</span>
        </div>
      </div>
    </div>
  );
};

const Aboutus = () => {
  return (
    <div>
      <Navbar />
      <div className="about-banner">
        <h2>About Us</h2>
        <p className="md:w-[70%] w-[96%] px-[16px]">
          We are a technology-driven company dedicated to delivering innovative
          digital solutions that empower businesses and individuals to thrive in a
          rapidly evolving world. Our expertise spans software development, cloud
          integration, and digital transformation, ensuring our clients stay
          ahead of the curve. Whether you are a startup or an established
          enterprise, our team is committed to providing reliable, scalable, and
          user-centric solutions tailored to your unique needs. Join us as we
          shape the future of technology together!
        </p>
      </div>
      {/* <div className="launching-sec">
        <CountdownTimer
          initialDays={10}
          initialHours={1}
          initialMinutes={30}
          initialSeconds={45}
        />
      </div> */}
      <div className="about-white-line px-[16px]">
        <div className="about-des container pt-5">
            <h3>Empowering Your Digital Journey</h3>
            <p>Our mission is to transform the way organizations and individuals leverage technology by providing smart, accessible, and secure digital tools. We streamline operations, enhance productivity, and foster innovation, helping our clients achieve their goals with confidence and clarity.</p>
        </div>
        <div className="lap-img pb-5">
            <img src={aboutlap} alt="About Us" className="img-fluid" />
        </div>
        <div className="about-location py-5">
            <div className="about-des-location container mx-auto">
            <h3>Our Location</h3>
            <p className="md:w-[50%] w-[96%]">Shop No. 203 <br  /> II Floor, Hiltan Arcade Shopping Center, Evershine City <br className="hidden md:block" /> Gokhivare,  Vasai East, Vasai, Mumbai - 401208.</p>
            </div>
            
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Aboutus;
